'use strict';
const _ = require('lodash');
const $ = require('jquery');
const Backbone = require('backbone');
const slugify = require('./util/helpers').slugify;

const Router = require('./routes/router');
const ModelAd = require('./models/ad');
const ModelAuth = require('./models/auth');
const ModelBase = require('./models/base');
const ModelCms = require('@telescope/tscom-cms');
const ModelConnect = require('./models/connect');
const ModelGeo = require('tscom-geo');
const ModelGoogle = require('./models/google');
const ModelPJS = require('./models/pjs');
const ModelShare = require('./models/share');
const ModelStorage = require('./models/storage');
const ModelTimer = require('./models/timer');
const ModelFacebook = require('@telescope/tscom-facebook');
const CollectionCategory = require('./collections/category');
const PubSub = require('./PubSub');
const { initializeGA4, trackPageView } = require('./util/ga4');
const google = require('./models/google');

// constants
const CONNECT = require('./constants').CONNECT;
const APP_SETTINGS = require('./constants').APP_SETTINGS;

// helper functions
const getQueryParamByName = require('./util/helpers').getQueryParamByName;
const getDeviceType = require('./util/helpers').getDeviceType;
const omniture = require('./util').omniture;

/**
 * @param options - {
 * widget_id: 'data/data.json' // REQUIRED string
 * container: $('#myWidget') // REQUIRED string || jQuery selector (https://api.jquery.com/jQuery/) || element reference (https://developer.mozilla.org/en-US/docs/Web/API/element)
 * modal: $('#wrapper') // string || jQuery selector (https://api.jquery.com/jQuery/) || element reference (https://developer.mozilla.org/en-US/docs/Web/API/element)
 * uniqueId: 'name-type-namespace-datetime' // string
 * cssUrl: 'https://a1.telesocpe.tv/styles/main.css' // string (absolute path)
 * endpoints: {cms: 'https://stateapi-fs.votenow.tv/widgets/get'} // object
 * }
 */
function Controller(options) {

    options = options || {};
    options.widget_id = options.widget_id || '1110c12034e25961';
    options.endpoints = options.endpoints || {};

    _.extend(options.endpoints, {
        twitter: {
          url: 'https://twitterauth.votenow.tv', // overwritten in cms settigns
          tokenEndpoint: '/api/v1/auth/twitter/token',
          authEndpoint: '/api/v1/auth/twitter',
          sessionEndpoint: '/api/v1/auth/me'
        }
    });

    // properties
    this.nativeApp = options.native || false;
    this.device = getDeviceType();
    this.options = options;
    this.userAuth = false;
    this.selectedCategory = null;
    this.env = options.env;
    this.gaAllowed = false;
    this.cookieData = {};

    // other properties
    this.Models = {};
    this.Collections = {};
    this.Views = {};
    this.Routers = {};
    this.Data = {
        shareUrl: options.shareUrl
    };

    this.createCmsModel()
    .then( this.createGeoModel.bind( this ))
    .then( this.createAuthModels.bind( this ))
    .then( this.createCategoriesModel.bind( this ))
    .then( this.createConnectModel.bind( this ))
    .then( this.createContestantsModel.bind( this ))
    .then( this.createPlayerModel.bind( this ))
    //.then( this.createVevoModel.bind( this ))
    // .then( this.createYoutubeModel.bind( this ))
    .then( this.createAdModel.bind( this ))
    .then( this.createShareModel.bind( this ))
    .then( this.createTimerModel.bind( this ) )
    .then( this.createTimerModelClosed.bind( this ))
    .then( this.createHeaderModel.bind( this ))
    .then( this.createCollections.bind( this ))
    .then( this.createFooterModel.bind( this ))
    .then( this.createProgressModel.bind( this ))
    .then( this.createGridModel.bind( this ))
    .then( this.setMiscellaneous.bind( this ))
    .then( this.setListeners.bind( this ))
    .then( this.createTurboVoteModel.bind( this ))
    .then( this.createRouter.bind( this ));

}

Controller.prototype = _.extend({
    /**
     * createCmsModel
     */
    createCmsModel: function() {
        this.Models.Cms = new ModelCms({
            wid: this.options.widget_id,
            apiUrl: this.options.endpoints.cms,
            localTime: new Date().getTime()
        },{
            ignoreQSP: false
        });

        return this.Models.Cms.fetch();
    },
    /**
     * createGeoModel
     */
    createGeoModel: function() {
        // Akamai Geo Location
        this.Models.Geo = new ModelGeo({
            countries: this.Models.Cms.get('settings').countries
        });

        var updatedEndpoint = this.options.appRoot + 'api/getregion.json';
        this.Models.Geo.urlRoot = updatedEndpoint;
        this.Models.Geo.url = updatedEndpoint;

        return this.Models.Geo.fetch();
    },
    /**
     * createGoogleModel
     */
    createAuthModels: function() {
        this.createFacebookModel();

        // Create Google Login model
        const googleClientId = this.Models.Cms.get('settings').google_client_id;

        this.Models.GoogleLogin = new ModelGoogle( {
            googleClientId: googleClientId
        } );

        // Create models for local storage and cookies
        this.Models.Storage = new ModelStorage();
        this.Models.Cookie = new ModelStorage({
          storageMethod: 'cookie'
        });

        // Create our Auth model
        this.Models.Auth = new ModelAuth({}, {
            google: this.Models.GoogleLogin,
            storage: this.Models.Storage,
            facebook: this.Models.Facebook
        });

        this.listenTo( this.Models.GoogleLogin, 'prompt', function() {
            if( this.Models.Auth.get('authType') === null ) {
                window.google.accounts.id.prompt();
            }
        });

        // Model for Google Analytics
        if(window.cbsoptanon) {
            window.cbsoptanon.cmd.push(function(cmp) {
              cmp.ot.performanceAllowed(function(allowed) {
                this.gaAllowed = allowed;
                if (allowed) {
                    initializeGA4( this.Models.Cms.get('settings').google_analytics );
                }
              }.bind(this));
            }.bind(this));
        }
    },
    createFacebookModel: function() {
        const socialSettings = this.Models.Cms.get('social');
        const authSettings = this.Models.Cms.get('text').view_auth;

        const appId = socialSettings.fb.id;

        if( _.checkIfTrue( authSettings.enable_facebook_login ) )  {
            const fbModel = this.Models.Facebook = new ModelFacebook({
                appId: appId
            }, {
                version: 'v16.0',
                manageFbloCookie: false
            });

            this.listenTo(
                fbModel,
                'change:id',
                function() {
                    const fbId = fbModel.get('id');
                    if( fbId ) {
                        this.Models.Auth.signInSuccess( 'facebook', fbModel );
                        PubSub.trigger('directRoute', 'closeCurrentModal');
                    }
                }.bind(this)
            );
        }
    },
    /**
     * create camp stats model
     */
    createTurboVoteModel: function() {
        const cmsSettings = this.Models.Cms.get('settings');
        const enableTurboPolling = _.checkIfTrue(this.Models.Cms.get('text').enable_turbo_polling);
        const p = $.Deferred();

        this.Models.TurboVote = new ModelConnect({
            apiKey: cmsSettings.apiKey_turbo
        },{
            cms: this.Models.Cms,
            getContextData: this.getContextData.bind(this),
            getUserData: function() { return {} },
            version_id: cmsSettings.version_id_turbo
        })

        this.Models.TurboVote.versionCheck = CONNECT.TURBO_VERSION_CHECK;

        if( this.env === 'test' ) {
            this.Models.TurboVote.apiUrl = 'https://voteapi-test.votenow.tv/s2/vote'
        }

        this.Models.TurboVoteProperty = new Backbone.Model({
            value: 'false',
            voteLimit: this.Models.Cms.get('text').vote_limit,
        });

        this.Models.Cms.turboVote = this.Models.TurboVoteProperty;


        this.listenTo( this.Models.TurboVote, 'change:requestActionGetPayload', function() {
            const turboWindow = this.Models.TurboVote.get('requestActionGetPayload').turbo_window;
            const isTurbo = _.checkIfTrue( turboWindow );
            const text = this.Models.Cms.get('text');

            const props = {
                voteLimit: isTurbo ? text.turbo_vote_limit : text.vote_limit,
                value: turboWindow
            };

            this.Models.TurboVoteProperty.set( props );

            this.stopListening( this.Models.TurboVoteProperty, 'change:value', this.refreshPage );
            this.listenTo( this.Models.TurboVoteProperty, 'change:value', this.refreshPage );

            p.resolve();
        }.bind(this) );

        if( this.Models.Cms.get('appState') === 'open' && enableTurboPolling) {
            this.Models.TurboVote.getEvery( parseInt(cmsSettings.turbo_window_poll_rate_ms, 10) );
        } else {
            p.resolve();
        }

        return p;
    },
    /**
     * createConnectModel
     */
    createConnectModel: function() {
        const settings = this.Models.Cms.get('settings');
        const isLiveVote = _.checkIfTrue( this.Models.Cms.get('text').live_vote );
        const apiKey = isLiveVote ? settings.apiKey_twttr : settings.apiKey;
        const versionId = isLiveVote ? settings.version_id_twttr : settings.version_id;
        const versionCheck = isLiveVote ? CONNECT.TWITTER_VERSION_CHECK : CONNECT.CONNECT_VERSION_CHECK;
        const numCategories = this.Models.Categories.get('data').length;

        this.Models.Connect = new ModelConnect({
            apiKey: apiKey
        },{
            cms: this.Models.Cms,
            getContextData: this.getContextData.bind(this),
            getUserData: this.getUserData.bind(this),
            version_id: versionId,
            numberOfCategories: numCategories
        })

        this.Models.Connect.versionCheck = versionCheck;

        if( this.env === 'test' ) {
            this.Models.Connect.apiUrl = 'https://voteapi-test.votenow.tv/s2/vote'
        }
    },
    /**
     * createPlayerModel
     */
    createPlayerModel: function() {
        this.Models.Player = new ModelPJS({}, {});
    },
    /**
     * createVevoModel
     */
    // createVevoModel: function() {
    //     this.Models.Vevo = new ModelVevo({}, {});
    // },
    /**
     * createYoutubeModel
     */
    // createYoutubeModel: function() {
    //     this.Models.YouTube = new ModelYoutube({}, {});
    // },
    /**
     * createAdModel
     */
    createAdModel: function() {
        this.Models.Ad = new ModelAd({}, {});
    },
    /**
     * createShareModel
     */
    createShareModel: function() {
        var cmsText = this.Models.Cms.get('text');
        this.Models.Share = new ModelShare({
            copy: cmsText.view_share,
            share: cmsText.view_share.share,
            uid: this.uniqueId,
            native: this.nativeApp,
            fbId: this.Models.Cms.get('social').fb.id
        }, {});
    },
    /**
     * createTimerModel
     * This uses a reset given only the time, so let's add the date today
     */
    createTimerModel: function() {
        var countdownCopy = this.Models.Cms.get('text').view_countdown;
        var endDate = new Date( new Date(this.Models.Cms.get('text').view_countdown.end_date).toLocaleString('en-US', { timeZone: 'America/Los_Angeles' } ) );
        var date = new Date( new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' } ) );
        var month = date.getMonth() + 1; // January returns 0
        var day = date.getDate();
        var year = date.getFullYear();

        var resetDate = ('0'+ month).slice(-2) + '/' + ('0' + day).slice(-2) + '/' + year + ' ' + countdownCopy.reset_time;
        var timeRemaining = parseInt((new Date(resetDate).getTime() - this.Models.Cms.get('ts')) / 1000, 10);

        if(timeRemaining <= 0) {
            // If the reset time has expired, set for the next day
            var tomorrow = new Date( date );
            tomorrow.setDate( tomorrow.getDate()  + 1);
            var tomorrowMonth = tomorrow.getMonth() + 1; // January returns 0
            var tomorrowDay = tomorrow.getDate();
            var tomorrowYear = tomorrow.getFullYear();

            resetDate = ('0'+ tomorrowMonth).slice(-2) + '/' + ('0' + (tomorrowDay)).slice(-2) + '/' + tomorrowYear + ' ' + countdownCopy.reset_time;
        }

        // only reset the timer if the end date is not reached yet
        var endTimestamp = endDate.getTime();
        var useResetDate = date.getTime() < endTimestamp;

        this.Models.Timer = new ModelTimer({
            endTime: useResetDate ? resetDate : endDate,
            endTimestamp: endTimestamp,
            isResetting: useResetDate,
        }, { cms: this.Models.Cms });
    },
    /**
     * createTimerModelClosed
     */
    createTimerModelClosed: function() {
        var countdownCopy = this.Models.Cms.get('text').view_countdown_closed;
        var date = new Date( new Date());
        var endDate = new Date( new Date(this.Models.Cms.get('text').view_countdown_closed.end_date));
        var endTimestamp = endDate.getTime();
        var useResetDate = date.getTime() < endTimestamp;

        this.Models.TimerClosed = new ModelTimer({
            enableDays: true,
            endTime: endDate,
            endTimestamp: endTimestamp,
            isResetting: useResetDate,
        }, { cms: this.Models.Cms });
    },
    /**
     * createHeaderModel
     */
    createHeaderModel: function() {
        this.Models.Header = new ModelBase({
            copy: this.Models.Cms.get('text').view_header,
            countdownCopy: this.Models.Cms.get('text').view_countdown_closed,
            uid: this.options.uniqueId,
            window: this.Models.Cms
        }, {
            textKey: 'view_header',
            cms: this.Models.Cms
        });
    },
    /**
     * createFooterModel
     */
    createFooterModel: function() {
        this.Models.Footer = new ModelBase({
            copy: this.Models.Cms.get('text').view_footer,
            uid: this.options.uniqueId,
            countdownCopy: this.Models.Cms.get('text').view_countdown,
            auth: this.Models.Auth,
            window: this.Models.Cms
        }, {
            textKey: 'view_footer',
            cms: this.Models.Cms
        });
    },
    /**
     * createCategoriesModel
     */
    createCategoriesModel: function() {
        var wid = getQueryParamByName('category_wid') || this.Models.Cms.get('settings').category_wid;
        var sid = getQueryParamByName('category_sid') || undefined;

        // create the categories model and fetch the data
        this.Models.Categories = new ModelCms({
            id: APP_SETTINGS.CATEGORY_CMS_ID,
            wid: wid,
            sid: sid,
            updateFrequency: APP_SETTINGS.CMS_POLL_RATE,
            copy: this.Models.Cms.get('text').view_grid
        }, {
            ignoreQSP: true
        });

        return this.Models.Categories.fetch();
    },
    /**
     * createContestantsModel
     */
    createContestantsModel: function() {
      var wid = getQueryParamByName('contestant_wid') || this.Models.Cms.get('settings').contestant_wid;
      var sid = getQueryParamByName('contestant_sid') || undefined;

      // create the contestants model and fetch the data
      this.Models.Contestants = new ModelCms({
          id: APP_SETTINGS.CONTESTANT_CMS_ID,
          wid: wid,
          sid: sid,
          updateFrequency: APP_SETTINGS.CMS_POLL_RATE
      }, {
          ignoreQSP: true
      });

      return this.Models.Contestants.fetch();
  },
    /**
     * createCollections
     */
    createCollections: function() {
      var categoryOptions = _.clone(this.Models.Categories.get('data'), true);
      var categories = _.where(categoryOptions, { professional: '0' });
      var professionals = _.where(categoryOptions, { professional: '1' });
      var voteOptions = _.clone(this.Models.Contestants.get('data'), true);
      var mergedData = this.mergeDataSets( categories, voteOptions );
      var mergedDataProfessional = this.mergeDataSets( professionals, voteOptions );

      this.Collections.Categories = new CollectionCategory(mergedData);
      this.Collections.Professional = new CollectionCategory(mergedDataProfessional);
    },
    /**
     * createProgressModel
     */
    createProgressModel: function() {
        var cmsModel = this.Models.Cms;
        this.Models.Progress = new ModelBase({
            copy: cmsModel.get('text').view_progress,
            uid: this.options.uniqueId,
            auth: this.Models.Auth,
            categories: this.Collections.Categories,
            window: cmsModel
        }, {
            textKey: 'view_progress',
            cms: cmsModel
        });

    },

    /**
     * createGridModel
     */
    createGridModel: function() {
        var cmsModel = this.Models.Cms;
        var cmsText = cmsModel.get( 'text' );
        this.checkWindow();

        this.Models.Grid = new ModelBase({
            uid: this.options.uniqueId,
            collection: this.Collections.Categories,
            professionals: this.Collections.Professional,
            user: this.Models.Auth,
            dimensions: cmsText.customization.contestant_images,
            copy: cmsText.view_grid,
            window: cmsModel
        }, {
            textKey: 'view_grid',
            cms: cmsModel
        });
    },
    /**
     * setMiscellanous
     */
    setMiscellaneous: function() {
        // fetch the device information
        this.tacobellID = this.Models.Cms.get('text').customization.tacobell_category_id || "7";
    },
    /**
     * setListeners
     */
    setListeners: function() {
        var authModel = this.Models.Auth;
        var categoriesModel = this.Models.Categories;
        var cmsModel = this.Models.Cms;

        // Controller Model Listeners

        this.listenTo(this.Models.Auth, 'change:userID', this.getUserVotes.bind(this));
        this.listenTo(this.Models.Auth, 'change:authType', function() {
            if( this.Models.Auth.get('authType') !== 'google' && window.google ) {
                window.google.accounts.id.cancel();
            }
        }.bind(this));
        this.Models.Auth.initializeType();

        this.listenTo( cmsModel, 'change:windowStatus', this.checkWindow.bind( this ));
        this.listenTo( this.Models.Contestants, 'change:data', this.updateCategory.bind( this, this ));
        this.listenTo( cmsModel, 'change:sid', this.refreshPage );

        // Categories Model
        this.listenTo( categoriesModel, 'change:windowStatus', this.checkWindow.bind( this ));
        this.listenTo( categoriesModel, 'change:data', this.updateCategory.bind( this, this ));
        this.listenTo( categoriesModel, 'change:sid', this.refreshPage );

        this.listenTo( cmsModel, 'change:appState', function( model, appState ) {
            PubSub.trigger( 'appState', appState );
        });

        this.listenTo( PubSub, 'authenticated', authModel.signInSuccess.bind( authModel ) );
        this.listenTo( PubSub, 'logout', this.logout.bind( this ));
        this.listenTo( PubSub, 'submitVotes', this.registerUserVote.bind( this ));
        this.listenTo( PubSub, 'retryVoteAction', this.registerUserVote.bind( this ));
        this.listenTo( PubSub, 'userCancelVote', this.clearUserVote.bind( this ));
        this.listenTo( PubSub, 'resetAll', this.resetAll.bind( this ));
        this.listenTo( PubSub, 'resetCategories', this.resetCategories.bind( this ));

        // Handle instance a user cancels their auth registration
        // To clear the users cached data from the above PubSub
        this.listenTo( PubSub, 'userCancelAuth', function() {
            this.Models.Auth.set({isAuthorized: true}, {silent: true});
            this.Models.Auth.set({isAuthorized: false});
        }.bind( this ));

        this.listenTo( PubSub, 'emailLogin', authModel.signInSuccess.bind( authModel, 'email' ));
        this.listenTo( PubSub, 'linkClick', this.trackLinkClick.bind( this ));

        this.listenTo( PubSub, 'submitSweepstakes', function(params) {

            this.listenToOnce( PubSub, 'sweepsSuccess', function(data) {
                this.voteData = null;
                PubSub.trigger('navigate', 'thanks');
            }.bind( this ));

            this.Models.Connect.requestActionSweeps(params);
        }.bind( this ));

        /* MMA-692: multiple pageviews called on initial load
         * Because of our how app loads, the first category will always load first,
         * and once the action_type=get call fires, the next votable category will load
         * based on the user's vote string.  This is a workaround, but not ideal.
         */
        this.listenTo( PubSub, 'pageView', _.debounce(function(omParams, gaParams) {
            if (gaParams && this.gaAllowed) {
                trackPageView( gaParams.eventAction );
            }

            omParams.page = slugify(omParams.page);
            omniture.sendPageEvent(omParams);
        }.bind( this ), 1000));
    },
    /**
     * createRouter
     */
    createRouter: function() {
        var options = this.options;

        // MMA-441 - send initial page event
        omniture.sendPageEvent();

        this.Routers.Router = new Router({
            el: options.container,
            modal: options.modal,
            uid: options.uniqueId,
            controller: this,
            route: options.route,
            appRoot: options.appRoot
        });

        var backboneRoot = options.appRoot;

        Backbone.history.start({
            pushState: true,
            root: backboneRoot
        });
    },

    /* Helper Functions
    ------------------------------------------ */
    /**
     * delegateVote
     */
    delegateVote: function(data) {
      const isLiveVote = !!data.categoryVoteData.contestant;

      this.voteData = data;

      this.listenToOnce(PubSub, 'voteSuccess', function(response) {
        const recentVotedCategory = this.Collections.Categories.getCategoryById(this.voteData.categoryID);

        const currentCookie = this.Models.Cookie.fetch('votestring');
        // if current vote window id doesn't match id in current cookie, destroy cookie first to reset vote data
        if (currentCookie && this.cookieData['windowId'] !== response.window_id) {
            this.Models.Cookie.destroy('votestring');
        }

        // save the votestring and vote window to a cookie in case the user's IP is blocked
        const voteHistory = response.votestring.length > 0 ? JSON.parse( response.votestring ) : {};
        this.cookieData['windowId'] = response.window_id;

        Object.keys( voteHistory ).forEach( function( catId ) {
            const categoryData = voteHistory[ catId ];

            if( this.cookieData[catId] ) {
                const rulesetTotal = categoryData.total;
                let localTotal = this.cookieData[catId].total || 0;

                if( rulesetTotal > 1 ) {
                    localTotal = rulesetTotal;
                } else {
                    localTotal += 1;
                }

                this.cookieData[catId] = _.extend({},
                    this.cookieData[catId],
                    categoryData,
                    {
                        total: localTotal
                    });
            } else {
                this.cookieData[catId] = categoryData;
            }
        }.bind(this));

        this.Models.Cookie.save('votestring', JSON.stringify( this.cookieData ), '04:00:00 GMT');

        var lastVotedCatID = parseInt(this.voteData.categoryID, 10);

        if(recentVotedCategory) {

          const gaParams = {
            eventCategory: 'Vote Category Submit',
            eventAction: 'Unique Voter Category ' + this.voteData.categoryID
          };
          const catId = 'cat' + recentVotedCategory.get('id');

          this.trackLinkClick(null, gaParams);

          const isLiveCategory = _.checkIfTrue( recentVotedCategory.get('live_vote') );

          if( isLiveCategory && response.votestring ) {
            const categoryVoteHistory = this.cookieData[catId];

            const totalVotes = recentVotedCategory.get('categoryVotesTotal');
            const voteLimit  = parseInt( this.Models.TurboVoteProperty.get('voteLimit'), 10 );
            const isSubmitted = totalVotes >= voteLimit;

            if( categoryVoteHistory ) {
                recentVotedCategory.set({
                    categoryVotesTotal: categoryVoteHistory.total,
                    categoryVotes: _.omit(categoryVoteHistory, 'total'),
                    isSubmitted: isSubmitted
                });
            }
          } else {
            recentVotedCategory.set('isSubmitted', true);
          }
        }

        if( !isLiveVote ) {
            this.routeUserBasedOnVoting(lastVotedCatID);
        }

      }.bind(this));

      var omParams = {
        name: 'submit vote button_' + this.voteData.categoryName,
        section: slugify(this.voteData.categoryName),
        url: window.location.href
      };

      var gaParams = { eventCategory: 'Button Click', eventAction: 'Vote Submit' };
      this.trackLinkClick(omParams, gaParams);

      this.Models.Connect.requestActionVote(data);
    },
    /**
     * getContextData
     */
    getContextData: function() {
        var data = {
            timestamp: this.Models.Cms.get('ts'),
            country: this.Models.Geo.get('country'),
            state: this.Models.Geo.get('geoheaders').region
        };
        return data
    },
    /**
     * getUserData
     */
    getUserData: function() {
        var data = {
            user_id: this.Models.Auth.get('userID')
        };

        switch(this.Models.Auth.get('authType')) {
            case 'email':
                data.method = 'email';
                break;
            case 'facebook':
                data.method = 'fb';
                data.fb_first_name = this.Models.Auth.get('firstName');
                data.fb_email = this.Models.Auth.get('email');
                break;
            case 'google':
                data.email = this.Models.Auth.get('email');
                data.google_name = this.Models.Auth.get('userName');
                data.method = 'google';
                break;
        }

        Object.keys( data ).forEach( function(key) {
            if( data[key] === undefined || data[key] === '' ) {
                delete data[key];
            }
        });

        return data;
    },
    /**
     * Get Call for User Votes
     */
    getUserVotes: function(model, value, options) {
        if(!_.isNull(value)) {
            /**
             * ALL CLOSED - both main and categories widget will have open snapshots and the only indicator we
             * have that it's a closed state is there are no active categories, so we check if there are none
             */
            var activeCats = this.Models.Categories.get('data').filter(function(cat) {
                return cat.active === '1';
            });

            // return if there are no active categories OR any snapshot is closed
            if(!activeCats || this.Models.Categories.get('windowStatus') === 0 || this.Models.Cms.get('settings').window_status === '0') return;

            // set the namespace for the Cookie storage model
            this.Models.Cookie.set({ namespace: value });

            this.listenToOnce(this.Models.Connect, 'change:requestActionGetPayload', this.updateFromVoteHistory.bind(this));
            this.Models.Connect.requestActionGet();
        }
    },
    /**
     * Update the categories if votes have been submitted based on the user vote history
     */
    updateFromVoteHistory: function() {
        var voteString = this.Models.Connect.get('requestActionGetPayload');
        var votableCategories = this.Collections.Categories.getVotableCategories();

        if(!voteString) {
            // check for a votestring cookie if there is no votestring returned from the GET request
            var cookieVoteString = this.Models.Cookie.fetch('votestring');
            if(cookieVoteString) voteString = JSON.parse(cookieVoteString);
        } else {
            // destroy the votestring cookie if there is a votestring returned from the GET request
            this.Models.Cookie.destroy('votestring');
        }

        _.forEach(voteString, function(value, key) {

            const updatedKey = key.replace('cat', '');
            const votedCategory = this.Collections.Categories.getCategoryById(updatedKey);

            if( votedCategory ) {
                const isLiveCategory = _.checkIfTrue( votedCategory.get('live_vote') );
                const totalVotes = parseInt( value.total, 10 );
                const voteLimit  = parseInt( this.Models.TurboVoteProperty.get('voteLimit'), 10 );
                const isSubmitted = isLiveCategory ? totalVotes >= voteLimit : true;

                votedCategory.set({
                    isSubmitted: isSubmitted,
                    categoryVotes: _.omit(value, 'total'),
                    categoryVotesTotal: totalVotes
                });
            }

        }.bind(this));

        if(!votableCategories.length) {
            return PubSub.trigger('closeAllCategories');
        }

        this.routeUserBasedOnVoting();
        this.selectedCategory = null;
    },
    /**
     * [logout description]
     * @return {[type]} [description]
     */
    logout: function() {

        var authType = this.Models.Auth.get('authType');
        this.selectedCategory = null;
        
        if(_.isNull(authType))
            return;

        switch(authType) {
            case "facebook":
                this.Models.Facebook.logout();
                const appId = this.Models.Facebook.get('appId');
                this.Models.Facebook.set(
                    _.extend( {}, this.Models.Facebook.defaults, {
                        appId: appId
                    })
                );
                break;
            case "google":
                this.Models.GoogleLogin.signout();
                break;
            case "email":
                this.Models.Auth.deAuthorize();
                break;
            default:
        }

        this.resetAll();
    },
    /**
     * Reset the Auth model and Category collection
     */
    resetAll: function() {
        this.Models.Auth.set(this.Models.Auth.defaults);
        this.cookieData = {};
        this.voteData = null;
        $('.votes-remaining').text(this.Models.TurboVoteProperty.get('voteLimit'));
        this.resetCategories();
    },
    /**
     * Reset the Category collection when the daily countdown ends
     */
    resetCategories: function() {
        this.Collections.Categories.forEach(function(category) {
            category.set({
                categoryVotes: {},
                hasAlreadyConfirmed: false,
                isSubmitted: false,
                totalAllocatedVotes: 0,
                categoryVotesTotal: 0
            });
        });

        var route = this.Collections.Categories.getNextVotableCategory(0);

        if( route ) {
            PubSub.trigger('closeAllCategories', route.get('displayName'), route.get('id'));
        }
    },
    /**
     * [checkWindow description]
     * @return {[type]} [description]
     */
    checkWindow: function() {

        var windowStatus = parseInt(this.Models.Cms.get('windowStatus'));
        var windowStatusCategory = parseInt(this.Models.Categories.get('windowStatus'));

        switch (windowStatus) {
        /**
         * OPEN WINDOW
         */
            case 1:
                // do nothing since the window is open
                if(windowStatusCategory) {
                    // set an attribute to listen to
                    // voting window is opened, allow all voting to continue
                    this.Models.Cms.set({appState: "open"});
                } else {
                    // set an attribute to listen to
                    // voting window is closed, display the accordian only and update the text
                    this.Models.Cms.set({appState: "closed"});
                }
                break;
        /**
         * CLOSED WINDOW
         */
            case 0:
                // Show Closed Window
                // display the categories and the winners for each category
                // remove the winner from the nominees

                this.Models.Cms.set({appState: "winner"});
                break;
        }

    },
    /**
     * [routeUserBasedOnVoting description]
     * @return {[type]} [description]
     */
    routeUserBasedOnVoting: function(lastVotedCatID) {

      if(!this.Models.Auth.get('isAuthorized')) return;
      const selectedCategoryID = this.selectedCategory? this.selectedCategory.categoryID: null;
      let nextRoute;

      if( !lastVotedCatID ) {
        nextRoute = this.Collections.Categories.getNextVotableCategory(null, selectedCategoryID);
      }

      if( !nextRoute ) {
        nextRoute = this.Collections.Categories.getNextVotableCategory(lastVotedCatID, selectedCategoryID);
      }

      if(!lastVotedCatID && !nextRoute) {
          return PubSub.trigger('closeAllCategories');
      }

      // if user did not vote and the selected category is the same as the next votable category, return early
      if(!lastVotedCatID && nextRoute && this.selectedCategory && nextRoute.get('id') === this.selectedCategory.categoryID) {
          return;
      }

      if(!nextRoute) {
        PubSub.trigger('closeAllCategories');

        let intersitialRoute = 'thanks';
        const displaySweeps = _.checkIfTrue( this.Models.Cms.get('text').view_sweepstakes.display );
        const displayPoll = _.checkIfTrue( this.Models.Cms.get('text').view_poll.display );

        if( displaySweeps ) {
            intersitialRoute = 'sweeps';
        } else if ( displayPoll ) {
            intersitialRoute = 'poll';
        } else {
            intersitialRoute = 'thanks';
        }

        PubSub.trigger('navigate', intersitialRoute);
        return;
      }

      var hideAnimation = !(lastVotedCatID || selectedCategoryID);
      PubSub.trigger('closeAllCategories', nextRoute.get('displayName'), nextRoute.get('id'), null, hideAnimation);
    },
    /**
     * Check if the user is logged in before submitting the category votes
     */
    registerUserVote: function(data) {
        if(!this.Models.Auth.get('isAuthorized')) {
            this.Models.Auth.once('change:isAuthorized', function(data, cb) {
                if(!this.Models.Auth.get('isAuthorized')) return;
                this.delegateVote(data);
            }.bind(this, data));

            const selected = {
                categoryID: data.categoryID,
                contestantID: data.contestantID
            };
            PubSub.trigger('directRoute', 'auth', selected);
            return;
        }
        this.delegateVote(data);
    },
    /**
     *
     */
    clearUserVote: function() {
        this.voteData = null;
        this.callback = null;
    },
    /**
     * Track link clicks on Google Analytics and Omniture
     */
    trackLinkClick: function(omParams) {
        if(omParams) omniture.sendClickEvent(omParams);
    },
    /**
     * mergeDataSets
     */
    mergeDataSets: function (categories, dataOptions) {

      categories.forEach(function (cat, index, list) {

        var voteOptions = dataOptions.filter(function(option) {
          return option.category_id === cat.id;
        });

        cat.winner = voteOptions.find(function(option) {
          return option.winner === '1'
        });

        cat.copy = this.Models.Cms.get('text').view_grid;

        cat.voteData = voteOptions.sort( function(a, b) {
          if ( a.winner !== b.winner ) return parseInt( b.winner, 10 ) - parseInt( a.winner, 10 );
          return parseInt( a.order, 10 ) - parseInt( b.order, 10 );
        });

        cat.ad = this.Models.Ad;
        cat.displayName = slugify(cat.name);

      }.bind(this));

      return categories;
    },
    /**
     * updateCategory
     */
    updateCategory: _.debounce(function (controller) {

        var categories = _.clone(controller.Models.Categories.get('data'), true);
        var category = categories.filter(function(cat) {
          return cat.professional === '0';
        });
        var professional = categories.filter(function(cat) {
          return cat.professional === '1';
        });

        var voteOptions = _.clone(controller.Models.Contestants.get('data'), true);

        var mergedData = this.mergeDataSets(category, voteOptions);
        var mergedDataPromoted = this.mergeDataSets(professional, voteOptions);

        if(controller.Collections.Categories instanceof CollectionCategory) {
          controller.Collections.Categories.set(mergedData, {merge: true});
        }

        if(controller.Collections.Professional instanceof CollectionCategory) {
          controller.Collections.Professional.set(mergedDataPromoted, {merge: true});
        }

        category = professional = voteOptions = mergedData = null;

    }, 1000, { leading: true }),
    /**
     * refreshPage
     */
    refreshPage: function() {
        try {
            window.location.reload();
        } catch (e) {
            var href = window.location.href.split('#')[0];
            window.location = href;
        }
    }

}, Backbone.Events);

module.exports = function( options ) {
    new Controller( options );
};



// WEBPACK FOOTER //
// ./app/scripts/App.js